// :cow: Cosmose CONFIDENTIAL :iso:
export function random(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}

export function randomString(length: number) {
  return Math.random().toString(36).substr(0, length);
}
